export default __webpack_public_path__ + "static/media/messageicon.799e2c96.svg";